import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";

import { videoPlayerService } from "../../../services/video-player/VideoPlayerService";
import { formatNumberBasedOnLanguage } from "../../../helpers/MathHelpers";

export default observer(function TrackDetails() {
  const { currentTimestamp, timestamps } = videoPlayerService;

  const getTimestampText = useCallback(() => {
    if (currentTimestamp && timestamps) {
      return (
        <Link to={timestamps.getTimestampUrl(currentTimestamp)}>
          {formatNumberBasedOnLanguage(currentTimestamp.text)}
        </Link>
      );
    }
  }, [currentTimestamp, timestamps]);

  return <div className="video-track-details">{getTimestampText()}</div>;
});
